export default "__VITE_ASSET__BwJVLR9e__"